---
meta:
title: Imprint
description: Imprint of the Swiss Esports Hub
links: none
---


import ContentPageLayout from "../../components/ContentPageLayout";

# Imprint
## Address

SESF – Swiss Esports Federation

c/o MYI Entertainment GmbH

Postgasse 15-21

3011 Bern


## Commercial Register

Name: Swiss e-Sports Federation

Domicile: Bern

Commercial Register Company Number: CH-020.6.001.772-6

Legal Form: Association

export default ({ children }) => <ContentPageLayout>{children}</ContentPageLayout>;
